var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createElement } from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import Emittery from 'emittery';
import { createSearchStore } from './store';
import { SearchModuleActionType } from './store/reducers';
import { getVisitorId } from './utils/visitorId';
import { sendInsightsEvent } from './services/sendInsightsEvent';
import { SearchModuleContext, LocationContext } from './contexts';
import { SearchModuleUi } from './SearchModuleUi';
export class SearchModule extends Emittery {
    constructor(options) {
        super();
        this.queryTimeout = null; // eslint-disable-line @typescript-eslint/no-explicit-any
        this.options = options;
        this.store = createSearchStore();
        this.subscribeToQueryChange();
        this.subscribeToOpenChange();
    }
    getQuery() {
        return this.store.getState().value.replace(/\s+/g, ' ').trim();
    }
    getSportId() {
        var _a;
        return ((_a = this.store.getState().selectedSport) === null || _a === void 0 ? void 0 : _a.id) || null;
    }
    isOpen() {
        return this.store.getState().open;
    }
    subscribeToOpenChange() {
        let prevOpen = this.isOpen();
        this.store.subscribe(() => {
            const open = this.isOpen();
            if (open === prevOpen) {
                return;
            }
            prevOpen = open;
            if (open) {
                this.emit('open');
            }
            else {
                this.emit('close');
            }
        });
    }
    subscribeToQueryChange() {
        let prevQuery = this.getQuery();
        let prevSportId = this.getSportId();
        this.store.subscribe(() => {
            var _a;
            const query = this.getQuery();
            const sportId = this.getSportId();
            if (query === prevQuery && sportId === prevSportId) {
                return;
            }
            prevQuery = query;
            prevSportId = sportId;
            this.stopQueryPropagation();
            this.queryTimeout = setTimeout(() => this.emit('query', { query, sportId }), (_a = this.options.debounceQuery) !== null && _a !== void 0 ? _a : 500);
            this.emit('queryImmediate', { query, sportId });
        });
    }
    stopQueryPropagation() {
        clearTimeout(this.queryTimeout);
        return this;
    }
    setQuery(value) {
        this.store.dispatch({ type: SearchModuleActionType.changeValue, payload: value });
        return this;
    }
    setOpen(open) {
        this.store.dispatch({ type: SearchModuleActionType.changeOpen, payload: open });
        return this;
    }
    setLoading(loading) {
        this.store.dispatch({ type: SearchModuleActionType.changeLoading, payload: loading });
        return this;
    }
    setEntries(entries, categories = {}, queryIDs = {}, searched) {
        this.store.dispatch({
            type: SearchModuleActionType.changeEntries,
            payload: { entries, searched },
        });
        this.store.dispatch({ type: SearchModuleActionType.changeCategories, payload: categories });
        this.store.dispatch({ type: SearchModuleActionType.changeQueryIDs, payload: queryIDs });
        return this;
    }
    setPopularQueries(queries) {
        this.store.dispatch({ type: SearchModuleActionType.changePopularQueries, payload: queries });
        return this;
    }
    setPreviousQueries(queries) {
        this.store.dispatch({ type: SearchModuleActionType.changePreviousQueries, payload: queries });
        return this;
    }
    removePreviousQuery(query) {
        this.emit('removePreviousQuery', query);
    }
    setPriceFormat(format) {
        this.store.dispatch({ type: SearchModuleActionType.changePriceFormat, payload: format });
        return this;
    }
    setSelectedSelections(selections) {
        this.store.dispatch({
            type: SearchModuleActionType.changeSelectedSelections,
            payload: selections,
        });
        return this;
    }
    setSports(sports) {
        this.store.dispatch({ type: SearchModuleActionType.changeSports, payload: sports });
        return this;
    }
    setSelectedSport(sportId) {
        const sports = this.store.getState().sports;
        const selectedSport = sports.find((sport) => sport.id === sportId) || null;
        this.store.dispatch({
            type: SearchModuleActionType.changeSelectedSport,
            payload: selectedSport,
        });
        return this;
    }
    sendInsightsEvent({ id, position, eventType, }) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const state = this.store.getState();
            const matchingItem = (_a = state.entries) === null || _a === void 0 ? void 0 : _a.find((entry) => entry.value.id === id);
            if (!matchingItem) {
                return Promise.resolve();
            }
            const index = matchingItem.type;
            const queryID = state.queryIDs[index];
            const insightsEvent = Object.assign({ userToken: getVisitorId(), eventType,
                index,
                queryID, objectIDs: [id] }, (position == null ? {} : { positions: [position] }));
            return sendInsightsEvent({ urlService: this.options.urlService, insightsEvent });
        });
    }
    render(element) {
        const { locale, urlService, translations } = this.options;
        const bareUi = createElement(SearchModuleUi, {
            onRemovePreviousQuery: this.removePreviousQuery.bind(this),
        });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const reduxUi = createElement(Provider, { store: this.store, children: bareUi });
        const ui = createElement(SearchModuleContext.Provider, { value: this }, reduxUi);
        const locationProviderUi = createElement(LocationContext.Provider, {
            value: {
                urlService,
                translations,
                locale,
            },
        }, ui);
        render(locationProviderUi, element);
    }
}
//# sourceMappingURL=SearchModule.js.map